require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2003-11-21-i-will-take-famous-titties-for.json") })
        }
      }, "path---articles-2003-11-21-i-will-take-famous-titties-for");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2003-11-21-i-will-take-famous-titties-for!./.cache/json/articles-2003-11-21-i-will-take-famous-titties-for.json
// module id = 341
// module chunks = 231608221292675